export const extendLocaleWithLatinNumerics = (locale: string) =>
  `${locale}-u-nu-latn`
